import BillManagerHowToQualifyScreen from 'features/billManager/screens/BillManagerHowToQualify/BillManagerHowToQualifyScreen';
import React from 'react';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

export default function HowToQualifyRoute() {
  return (
    <PinwheelContextProvider>
      <BillManagerHowToQualifyScreen />
    </PinwheelContextProvider>
  );
}
